// @todo add home page events

/**
 *  Onload Events which are added from the Dashboard
 */

var pageLoadEvent = document
  .getElementsByTagName("BODY")[0]
  .getAttribute("data-onloadevent");
var pageSlug = window.location.pathname;
pageSlug = pageSlug.replace(/^\/|\/$/g, "");
var homePage = document.getElementById("home-page");
if (homePage) {
  pageSlug = "homepage";
}

//HomePage OnLoad Experiment props
if (pageLoadEvent === "OnMainLandingPage") {
  var tftExpCookieKey = 'tft_exp_allocated';
  if (!Cookie.read(tftExpCookieKey)) {
    Cookie.create(tftExpCookieKey, 'homepage');
    tftExpAllocated = "homepage";
  } else {
    tftExpAllocated = Cookie.read(tftExpCookieKey);
  }
  if (homepageLiveForTeamsExp) {
    pageLoadEventProps = {"tft_exp":"variation", "tft_allocation_source": tftExpAllocated };
  } else {
    pageLoadEventProps = {"tft_exp":"control"};
  }
}

//Career page taxonomy on load event
if (pageSlug.indexOf('careers/') === 0) {
  var pageLocTitle = document.getElementById("page-location-title");
  pageLoadEvent = "OnCareersRegionPage";
  if (pageLocTitle) {
    pageLoadEventProps = {"regionName": pageLocTitle.getAttribute("data-text").trim()};
  }
}

//Trust Center Certificate Pages Onload events
if (document.body.classList.contains("single-trust_center") && pageSlug.indexOf('trust/') === 0) {
  pageLoadEvent = "OnTrustCenterCertificate";
  pageLoadEventProps = {
    "certificate_type": document.title,
    "certificate_category": trustCertificateCategory
  };
}

//Company page on load event
if (pageSlug.indexOf('company') === 0) {
  pageLoadEvent = "OnCompanyPage";
  pageLoadEventProps = {"action": "visit"};

  // Company Page Amplitude Events
var companyPageElements = document.querySelectorAll('.about-us-page-brands .call-to-action a, .product-card-container a, .card-b-3 a, .about-us-page-community-sec a, .about-us-page-we-are-sec a');

if (companyPageElements) {
  for (var i = 0; i < companyPageElements.length; i++) {
    companyPageElements[i].addEventListener('click', function () {
      var section = '';
      if (this.closest('.call-to-action' )) {
        section = "customers";
      } else if (this.closest('.product-card-container')) {
        section = "products";
      } else if (this.closest('.card-b-3')) {
        section = "webinar";
      } else if (this.closest('.about-us-page-community-sec')) {
        section = "community";
      } else if (this.closest('.about-us-page-we-are-sec')) {
        section = "company";
      } 
      WebEventTracker.logEvent(EDS.webEvents, "InteractedWithCompanyPage", {
        "action": "click",
        "section": section,
        "destination_url": this.getAttribute("href")
      });
    });
  }
}
}

if (pageSlug.indexOf('meetups') === 0) {
  pageLoadEvent = "VisitedMeetupsPage";
  pageLoadEventProps = {
    'signedin_state': wpUserLoggedIn
  };
}

if (pageSlug === '/webinars' || pageSlug.startsWith('webinars/') || pageSlug === '/browserstack-day' || pageSlug.startsWith('browserstack-day/')) {
  pageLoadEvent = "OnWebinarPage";
  pageLoadEventProps = {
    'signedin_state': wpUserLoggedIn
  };
}

if (pageSlug.indexOf('discord') === 0) {
  pageLoadEvent = "VisitedDiscordInvitePage";
  pageLoadEventProps = {
    'signedIn': wpUserLoggedIn
  };
}

/**
 * Pushing load events in an array and firing it after page load for these 5 pages.
 */
if (pageLoadEvent) {
  if (window.hasOwnProperty("loadWebTrackerEvents")) {
    loadWebTrackerEvents.push({
      eventName: pageLoadEvent,
      eventProperty: pageLoadEventProps,
    });
  }
}

/**
 * Amplitude Common Function, This was made during the Engg Task.
 * This function is attached to the button component.
 * and all other component having class name as "custom-btn-amp-events"
 */
var btnCTA = document.getElementsByClassName("custom-btn-amp-events");

if (btnCTA) {
  for (var i = 0; i < btnCTA.length; i++) {
    btnCTA[i].addEventListener("click", function () {
      var that = this, btnEventName = that.getAttribute("data-btn-eventname");
      if (btnEventName) {
        /**
         * We get string here so we need to add JSON.parse
         * and then pass to the Amplitude.logEvent
         * */
        var btnAmpJson = bsLib.JSONParse(that.getAttribute("data-btn-ampjson"));
        if (popUpCSFOptions.vwoShow && popUpCSFOptions.source !== "") {
          btnAmpJson['source'] = popUpCSFOptions.source;
        }

        // For variation Exp VWO
        if (popUpCSFOptions.vwoShow && popUpCSFOptions.hasOwnProperty('variant')) {
          btnAmpJson['variant'] = popUpCSFOptions.variant;
        }
        btnAmpJson['signedin_state'] = wpUserLoggedIn;
        WebEventTracker.logEvent(EDS.webEvents, btnEventName, btnAmpJson);
      }
    });

  }
}

var hoverBtnCTA = document.getElementsByClassName('custom-btn-amp-events-hover');

if (hoverBtnCTA) {
  for (var i = 0; i < hoverBtnCTA.length; i++) {
    hoverBtnCTA[i].addEventListener('mouseover', function () {
      var that = this,
        btnEventName = that.getAttribute('data-btn-hover-eventname');
      if (btnEventName && !that.classList.contains('event-triggered')) {
        that.classList.add('event-triggered');
        /**
         * We get string here so we need to add JSON.parse
         * and then pass to the Amplitude.logEvent
         * */
        var btnAmpJson = bsLib.JSONParse(that.getAttribute('data-btn-hover-ampjson'));

        btnAmpJson['signedin_state'] = wpUserLoggedIn;
        WebEventTracker.logEvent(EDS.webEvents, btnEventName, btnAmpJson);
      }
    });
  }
}

/**
 * Common Footer Amplitude Events.
 * This covers PRODUCTS, MOBILE, OTHER LINKS, KNOWLEDGE menus.
 */
var productsFooter = document.querySelectorAll("#menu-products > li > a"),
  mobileFooter = document.querySelectorAll("#menu-mobile > li > a"),
  otherLinksFooter = document.querySelectorAll("#menu-other-links > li > a"),
  knowledgeFooter = document.querySelectorAll("#menu-knowledge > li > a"),
  doMoreFooter = document.querySelectorAll(".footer-bottomlink-section ul > li > a"),
  solutionFooter = document.querySelectorAll("#menu-solutions > li > a"),
  toolsLinksFooter = document.querySelectorAll('#menu-tools > li > a'),
  productV3footer = document.querySelectorAll('#menu-footer-product-v3 > li > a'),
  whyBrowserstackV3footer = document.querySelectorAll('#menu-footer-why-browserstack-v3 > li > a'),
  freeToolsV3footer = document.querySelectorAll('#menu-footer-free-tools-v3 > li > a'),
  resourcesV3footer = document.querySelectorAll('#menu-footer-resources-v3 > li > a'),
  companyV3footer = document.querySelectorAll('#menu-footer-company-v3 > li > a'),
  moreResourcesV3footer = document.querySelectorAll('#menu-footer-more-resources-v3 > li > a'),
  testOnDeviceV3footer = document.querySelectorAll('#menu-footer-test-on-devices-v3 > li > a');

if (productV3footer) {
  for (i = 0; i < productV3footer.length; i++) {
    productV3footer[i].addEventListener("click", sendFooterClickEvent);
  }
}

if (whyBrowserstackV3footer) {
  for (i = 0; i < whyBrowserstackV3footer.length; i++) {
    whyBrowserstackV3footer[i].addEventListener("click", sendFooterClickEvent);
  }
}

if (freeToolsV3footer) {
  for (i = 0; i < freeToolsV3footer.length; i++) {
    freeToolsV3footer[i].addEventListener("click", sendFooterClickEvent);
  }
}

if (resourcesV3footer) {
  for (i = 0; i < resourcesV3footer.length; i++) {
    resourcesV3footer[i].addEventListener("click", sendFooterClickEvent);
  }
}

if (companyV3footer) {
  for (i = 0; i < companyV3footer.length; i++) {
    companyV3footer[i].addEventListener("click", sendFooterClickEvent);
  }
}
if (moreResourcesV3footer) {
  for (i = 0; i < moreResourcesV3footer.length; i++) {
    moreResourcesV3footer[i].addEventListener("click", sendFooterClickEvent);
  }
}
if (testOnDeviceV3footer) {
  for (i = 0; i < testOnDeviceV3footer.length; i++) {
    testOnDeviceV3footer[i].addEventListener("click", sendFooterClickEvent);
  }
}

if (productsFooter) {
  for (i = 0; i < productsFooter.length; i++) {
    productsFooter[i].addEventListener("click", sendFooterClickEvent);
  }
}

if (mobileFooter) {
  for (i = 0; i < mobileFooter.length; i++) {
    mobileFooter[i].addEventListener("click", sendFooterClickEvent);
  }
}

if (otherLinksFooter) {
  for (i = 0; i < otherLinksFooter.length; i++) {
    otherLinksFooter[i].addEventListener("click", sendFooterClickEvent);
  }
}

if (knowledgeFooter) {
  for (i = 0; i < knowledgeFooter.length; i++) {
    knowledgeFooter[i].addEventListener("click", sendFooterClickEvent);
  }
}

if (doMoreFooter) {
  for (i = 0; i < doMoreFooter.length; i++) {
    doMoreFooter[i].addEventListener("click", sendFooterDoMoreLinkClickEvent);
  }
}

if (solutionFooter) {
  for (i = 0; i < solutionFooter.length; i++) {
    solutionFooter[i].addEventListener("click", sendFooterClickEvent);
  }
}

if (toolsLinksFooter.length) {
  for (i = 0; i < toolsLinksFooter.length; i++) {
    toolsLinksFooter[i].addEventListener("click", sendFooterClickEvent);
  }
}

function sendFooterClickEvent() {
  var that = this;
  var value = that.textContent;
  var group =
    that.parentElement.parentElement.parentElement.firstElementChild
      .textContent;
  if (value && group) {
    WebEventTracker.logEvent(EDS.webEvents, "ClickedOnFooter", {
      value: value,
      group: group,
    });
  }
}

function sendFooterDoMoreLinkClickEvent() {
  var that = this,
    value = that.textContent,
    group = "Do more with BrowserStack";
    
  if (value && group) {
    WebEventTracker.logEvent(EDS.webEvents, "ClickedOnFooter", {
      value: value,
      group: group,
    });
  }
}

/**
 * Functions for Product Pages Amplitude.
 * @todo: Please remove "landedOnProductPage" Event name and pass it via dashboard.
 */

var homePage = document.getElementById("home-page");

/**
 * Home Page Amplitude Events
 * @todo There are multiple events static make them dynamic.
 */

if (homePage) {
  /**
   * Home Page Individual Elements Click
   */
  var homeHeroCta = document.querySelectorAll("#heroUnitMainSection .btn"),
    viewAllTestimonials = document.getElementById("view-all-testimonials"),
    viewAllIntegrations = document.querySelector('.integration-section__block + a.btn'),
    productCards = document.querySelectorAll(
      ".product-cards-wrapper--click--hoverclick"
    ),
    productPanelBtns = document.querySelectorAll(
      ".custom-product-btn"
    ),
    action,
   ctaLocation,
   eventObj,
   controlProductHoverFlag = [];

   function homePageMultiClickEvents(elem, eventAction) {
    var product = elem.getAttribute("title");
    eventName = "InteractedwithProductCard";
    eventObj = bsLib.extend({
      action: eventAction,
      product: product + ' Product',
      location: "Homepage Control Product Card"
    },
      ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {}
    ));
    homePageSingleClickEvents(eventName, eventObj);
  }

  // add on switch product tab events trigger function
  function setEventsOnProductPanelCta() {
    var product = this.getAttribute("title");
    eventName = "InteractedwithProductCard";
    eventObj = bsLib.extend({
      product: product,
      cta: "Card",
      action: "Learn More Clicked"
    },
      ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {}
    ));
    homePageSingleClickEvents(eventName, eventObj);
  }

  function homePageSingleClickEvents(eventName, eventObj) {
    if (eventName) {
      WebEventTracker.logEvent(EDS.webEvents, eventName, eventObj);
    }
  }

  

  if (homeHeroCta) {
    for (i = 0; i < homeHeroCta.length; i++) {
      homeHeroCta[i].addEventListener(
        "click",
        function () {
          eventName = "InteractedWithHomePage";
          eventObj = bsLib.extend({
            action: (this.text ? this.text : this.textContent) + " Hero Click", 
            "cta-location": "Hero" 
          },
            ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {}
          ));
          homePageSingleClickEvents(eventName, eventObj);
        },
        false
      );
    }
  }

  if (viewAllTestimonials) {
    viewAllTestimonials.addEventListener(
      "click",
      function () {
        eventName = "InteractedWithHomePage";
        eventObj = bsLib.extend({
          action: "View all testimonials Body Click",
          "cta-location": "section",
        },
          ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {}
        ));
        homePageSingleClickEvents(eventName, eventObj);
      },
      false
    );
  }

  if (viewAllIntegrations) {
    viewAllIntegrations.addEventListener(
      "click",
      function () {
        eventName = "InteractedWithHomePage";
        eventObj = bsLib.extend({
          action: "View all Integrations Click",
          "cta-location": "Integration section",
        },
          ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {}
        ));
        homePageSingleClickEvents(eventName, eventObj);
      },
      false
    );
  }

  /**
   * Amplitude Event for Home Page Product Cards.
   */
  if (productCards) {
    for (i = 0; i < productCards.length; i++) {
      productCards[i].addEventListener("click", function () {
        var that = this;
        homePageMultiClickEvents(that, 'Click');
      });
      //Attach Hover events on product links section
      productCards[i].addEventListener("mouseover", function () {
        var that = this;
        if (!controlProductHoverFlag.includes(that)) {
          homePageMultiClickEvents(that, 'Hover');
          controlProductHoverFlag.push(that);
        }
      });
    }
  }

  /**
   * Amplitude Event for Home Page Product Panel Btns.
   */
  if (productPanelBtns.length !== 0) {
    for (i = 0; i < productPanelBtns.length; i++) {
      productPanelBtns[i].addEventListener("click", setEventsOnProductPanelCta);
    }
  }
}

//Support page events start here
if ((document.body.classList.contains("page-template-page-support-v2")
  || document.body.classList.contains("tax-questions-categories") 
  || document.body.classList.contains("single-questions"))
  && document.body.classList.contains("enable-support-v2")) {
  pageLoadEvent = "VisitedHelpDesk";

  //load event
  if (window.hasOwnProperty("loadWebTrackerEvents")) {
    loadWebTrackerEvents.push({
      eventName: pageLoadEvent,
      eventProperty: helpDeskOptions,
    });
  }
}
//Support page events end here

/**
 * Product Page Events
 */
var landedOnProductPage, eventName, action, group_event;
var pageSlug = window.location.pathname;
pageSlug = pageSlug.replace(/^\/|\/$/g, "");

if (pageSlug == "live") {
  eventName = "InteractedWithLiveMarketingPage";
  landedOnProductPage = "OnLiveMarketingPage";
} else if (pageSlug == "automate") {
  eventName = "InteractedWithAutomateMarketingPage";
  landedOnProductPage = "OnAutomateMarketingPage";
} else if (pageSlug == "app-live") {
  eventName = "InteractedWithAppLiveMarketingPage";
  landedOnProductPage = "OnAppLiveMarketingPage";
} else if (pageSlug == "app-automate") {
  eventName = "InteractedWithAppAutomateMarketingPage";
  landedOnProductPage = "OnAppAutomateMarketingPage";
} else if (pageSlug == "percy") {
  eventName = "InteractedWithPercyMarketingPage";
  landedOnProductPage = "OnPercyMarketingPage";
} else if (homePage) {
  eventName = "InteractedWithHomePage";
}

/**
 * Page Load Event for four Product Pages
 */
if (landedOnProductPage) {
  /**
   * Load Event fired after Page Load
   */
  // WebEventTracker.logEvent("", landedOnProductPage, {});
  loadWebTrackerEvents.push({
    eventName: landedOnProductPage,
    eventProperty: pageLoadEventProps,
  });
}

// Product Pages Events start
/**
 * Amplitude Event for Secondary Navigation
 */
var productSecMenuClick = document.querySelectorAll(
  ".secondary-nav .product-menu li a:not(.nested-arrow-link), .secondary-nav_title > a"
),
productSecMenuCtaClick = document.querySelectorAll(
  ".sec_nav_cta.active li > a"
),
secNavEventHoverFlag = [];

if (productSecMenuClick) {
  for (var j = 0; j < productSecMenuClick.length; j++) {
    productSecMenuClick[j].addEventListener("click", function () {
      var that = this;
      sendSecHeaderMenuEvents(that, 'ClickedOnSecondaryHeader', 'Click');
    });

    //Attach Hover events on product links section
    productSecMenuClick[j].addEventListener("mouseover", function () {
      var that = this;
      if (!secNavEventHoverFlag.includes(that)) {
        sendSecHeaderMenuEvents(that, 'HoveredOnSecondaryHeader', 'Hover');
        secNavEventHoverFlag.push(that);
      }
    });
  }
}

if (productSecMenuCtaClick) {
  for (var k = 0; k < productSecMenuCtaClick.length; k++) {
    productSecMenuCtaClick[k].addEventListener("click", function () {
      var that = this;
      sendSecHeaderMenuEvents(that, 'ClickedOnSecondaryHeader', 'Click');
    });
  }
}

function sendSecHeaderMenuEvents(elem, menuEventName, eventAction) {
  var that = elem,
    linkTitle = that.getAttribute('title');
  
  group_event = linkTitle;
  action = (linkTitle ? linkTitle : that.getAttribute('aria-label')) + ' Secondary Navigation';

  //group update
  var getParentElem = that.closest('.custom-nested-secondary-nav');
  if (getParentElem) {
    group_event = getParentElem.querySelector('a').getAttribute('title');

    if (getParentElem.parentElement.closest('.custom-nested-secondary-nav')) {
      var nestedParentName = getParentElem.parentElement.closest('.custom-nested-secondary-nav').querySelector('a');
      if (that.parentElement.classList.contains('custom-nested-secondary-nav')) {
        group_event = nestedParentName ? nestedParentName.getAttribute('title') : group_event;
      }
    }
  }

  WebEventTracker.logEvent(EDS.webEvents, menuEventName, bsLib.extend({
    action: action,
    location: 'Secondary Header',
    group: group_event,
    properties_source : getHeaderProsfromURL(pageSlug),
    properties_destination : that.getAttribute("href")
  },
  ((popUpCSFOptions.vwoShow) ? { source: popUpCSFOptions.source } : {})
  ));

  // Click event on LP for menu items
  if (action && eventName && eventAction === 'Click') {
    WebEventTracker.logEvent(EDS.webEvents, eventName, {
      action: action,
    });
  }
}

function getHeaderProsfromURL(url) {
  var txt = '',
    //regex for check URL with domain name
    regex = new RegExp(
      '^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?'
    );

  //check url has domain name
  if (regex.test(url)) {
    var hostName = url.replace('http://', '').replace('https://', '').replace('www.', '').split(/[/?#]/)[0];

    //check url contain browserstack.com
    if (hostName === 'browserstack.com') {
      url = url.substring(url.indexOf(hostName) + hostName.length + 1, url.length);
    } else {
      url = hostName;
    }
  }

  if (!url || url.length === 0) {
    return '';
  }

  var URLArr = url.replace(/^\/|\/$/g, '').split('/');

  if (URLArr.length >= 2) {
    txt = URLArr[0].replaceAll('-', ' ') + ' ' + URLArr[1].replaceAll('-', ' ') + ' page';
  } else {
    txt = URLArr[0].replaceAll('-', ' ');
  }

  //check homepage
  txt = txt.length == 0 ? 'Home page' : txt;

  return txt;
}

if (landedOnProductPage) {
  /**
   * Amplitude Event for Hero CTA
   */
  var heroCTA = document.querySelectorAll(".hero-unit .button-section > a, .hero-unit .button-section > button");

  if (heroCTA) {
    for (i = 0; i < heroCTA.length; i++) {
      heroCTA[i].addEventListener("click", function () {
        if (eventName) {
          WebEventTracker.logEvent(EDS.webEvents, eventName, {
            action: (this.text ? this.text : this.textContent) + " Hero Click", 
            "cta-location": "Hero" 
          });
        }
      });
    }
  }

  /* Amplitude Event for Independent Elements Click */
  if (document.getElementById("view-all-testimonials")) {
    document
      .getElementById("view-all-testimonials")
      .addEventListener("click", function () {
        WebEventTracker.logEvent(EDS.webEvents, eventName, {
          action: "View all Testimonials Clicked",
        });
      });
  }
}
// Product Pages Events end here
   
/**
 * Page scroll depth event
 */
var scrollDepthEvents = [25, 50, 75, 100],
  hasFiredEvents = Array(scrollDepthEvents.length).fill(false);

function trackScrollDepth() {
  var pageHeight = document.body.scrollHeight - window.innerHeight,
    scrollPosition = window.scrollY || window.pageYOffset,
    scrollPercentage = Math.floor((scrollPosition / pageHeight) * 100); // Calculate scroll depth percentage

  // Iterate through the scroll depths array
  for (var i = 0; i < scrollDepthEvents.length; i++) {
    var currentDepth = scrollDepthEvents[i];

    // Check if the current scroll percentage is in the list to track and the event has not yet fired
    if (scrollPercentage >= currentDepth && !hasFiredEvents[i]) {
      hasFiredEvents[i] = true;
      fireScrollEvent(currentDepth);
    }
  }
}

function fireScrollEvent(scrollDepth) {
  var scrollDepthVal = scrollDepth / 100,
    eventName = 'ScrollDepth',
    eventObj = {
      ScrollDepth: scrollDepthVal,
    };

  if (window.hasOwnProperty('WebEventTracker')) {
    WebEventTracker.logEvent(EDS.webEvents, eventName, eventObj);
  }
}

// Attach the trackScrollDepth function to the scroll event
window.addEventListener("scroll", trackScrollDepth);

/**
 * Long Form and Guide Pages load event and Guide Split Pages Template
 */
var guideSplitElemExists = document.body.classList.contains("page-template-guide-split-exp-page"),
  guideBannerCTABtn = document.querySelectorAll('.guide-banner-section__btn-wrapper a'),
  guideFeaturedArticleCSFBtn = document.querySelectorAll('.guide-popup-csf__form--btn');

if (guideSplitElemExists) {
  pageLoadEventProps = {"Variation": "Hero Modal MLP"};
}

if (
  document.body.classList.contains("page-template-long-form-doc") ||
  document.body.classList.contains("single-guide") || 
  document.body.classList.contains("page-template-free-tools-inter-template") ||
  guideSplitElemExists
) {
  if (window.hasOwnProperty("loadWebTrackerEvents")) {
    loadWebTrackerEvents.push({
      eventName: "LoadArticle",
      eventProperty: pageLoadEventProps,
    });
  }
}

/**
 * loadWebTrackerEvents call
 * This function was made after moving Amplitude, EDS and Webtracker after Page Load.
 * This saves the Load Event and fires it after page load.
 * setInterval is added to avoid any mismatch in onLoad events that fires after the page load.
 */

var intStart = 0;
var eventTimer = setInterval(function () {

  if (window.hasOwnProperty("Amplitude")) {
    var ampObject, ampProperty;
    for (ampProperty in loadWebTrackerEvents) {
      ampObject = loadWebTrackerEvents[ampProperty];
      window.hasOwnProperty("WebEventTracker") &&
      typeof WebEventTracker === "object" &&
      WebEventTracker !== null
        ? WebEventTracker.logEvent(
            EDS.webEvents,
            ampObject["eventName"],
            ampObject["eventProperty"]
          )
        : "";
    }
    clearInterval(eventTimer);
  }
  if (++intStart >= 5) {
    clearInterval(eventTimer);
  }
}, 200);

/**
 * Calling Freshchat after page load for these 5 pages.
 */
var intVar = 0;
var freshchatInit = setInterval(function () {
  if (
    window.hasOwnProperty("freshChat") &&
    typeof freshChat === "object" &&
    freshChat !== null
  ) {
    //checked freshChat is object because Sentry gives "Cannot read property 'hasOwnProperty' of undefined"
    var checkFreshchat = freshChat.hasOwnProperty("init");
    checkFreshchat ? freshChat.init(false) : "";
    checkFreshchat ? clearInterval(freshchatInit) : "";
  }
  if (intVar > 5) {
    clearInterval(freshchatInit);
  }
  intVar += 1;
}, 200);

/**
 * Floating Banner Events
 */

// Get floatingBannerEvents object from header.php
var floatingBanner = document.querySelector(".floating-banner:not(.dg-floating-banner)");
if (floatingBanner) {
  var ctafloatingBanner = floatingBanner.querySelector("a.btn"),
  closefloatingBanner = floatingBanner.querySelector("span.close");
  ctafloatingBanner.addEventListener("click", function () {
    interactFloatingBannerFn(floatingBannerEvents.click);
  });
  closefloatingBanner.addEventListener("click", function () {
    interactFloatingBannerFn(floatingBannerEvents.close);
  });
}

function interactFloatingBannerFn(interaction) {
  WebEventTracker.logEvent(EDS.webEvents, floatingBannerEvents.interact, {
    action: interaction,
  });
}

/**
 * Send CaniuseReferral event when URL with ref=caniuse-source existing
 */
if (bsLib.getParameterByName("ref") === "caniuse-source") {
  WebEventTracker.logEvent(EDS.webEvents, "CaniuseReferral", {});
}